/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_Free_Feature_2Inputs */

const en_pricing_tier_free_feature_2 = /** @type {(inputs: Pricing_Tier_Free_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2x ultra-realistic voices`)
};

const es_pricing_tier_free_feature_2 = /** @type {(inputs: Pricing_Tier_Free_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 voces ultra realistas`)
};

/**
* | output |
* | --- |
* | "2x ultra-realistic voices" |
*
* @param {Pricing_Tier_Free_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_free_feature_2 = /** @type {((inputs?: Pricing_Tier_Free_Feature_2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_Free_Feature_2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_free_feature_2(inputs)
	return en_pricing_tier_free_feature_2(inputs)
});